/*
THIS INFRAGISTICS ULTIMATE SOFTWARE LICENSE  AGREEMENT ("AGREEMENT") LOCATED HERE:
https://www.infragistics.com/legal/license/igultimate-la
https://www.infragistics.com/legal/license/igultimate-eula
GOVERNS THE LICENSING, INSTALLATION AND USE OF INFRAGISTICS SOFTWARE. BY DOWNLOADING AND/OR INSTALLING AND USING INFRAGISTICS SOFTWARE:  you are indicating that you have read and understand this Agreement, and agree to be legally bound by it on behalf of the yourself and your company.
*/
import { markEnum } from "igniteui-react-core";
/**
 * Enumeration defining different positions a column can be fixed against.
 */
export var PinnedPositions = /*@__PURE__*/ (function (PinnedPositions) {
    /**
     * The column is not fixed.
     */
    PinnedPositions[PinnedPositions["None"] = 0] = "None";
    /**
     * The column is pinned against the left side of the grid.
     */
    PinnedPositions[PinnedPositions["Left"] = 1] = "Left";
    /**
     * The column is pinned against the right side of the grid.
     */
    PinnedPositions[PinnedPositions["Right"] = 2] = "Right";
    return PinnedPositions;
})({});
/**
 * @hidden
 */
export var PinnedPositions_$type = /*@__PURE__*/ markEnum('PinnedPositions', 'None,0|Left,1|Right,2');
//# sourceMappingURL=PinnedPositions.js.map
